import React, { useEffect } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import st from './PointsModal.module.scss'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'
import FormInput from 'components/UI/AsideModal/Form/FormInput'

const PointsModal = ({ initialPoints = '', initialComment = '' }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'study',
    subsection: 'tests',
    dict: {
      numberOfPoints: 'Number of points',
      comment: 'Comment',
    },
  })

  const handleCommentChange = (e) => {
    changeValues(e.target.value, 'employee_comment')
  }

  useEffect(() => {
    changeValues(initialPoints, 'employee_points')
    changeValues(initialComment, 'employee_comment')
  }, [initialPoints, initialComment])

  return (
    <div className={st.groupForm}>
      <FormField>
        <FormLabel>{translate?.numberOfPoints}:</FormLabel>
        <FormInput isError={check('test_scores')}>
          <input
            className={st.inputForNumber}
            placeholder={translate?.numberOfPoints}
            value={modalValue?.employee_points || ''}
            type={'number'}
            onChange={(e) => {
              const value = e.target.value
              if (Number(value) >= 0 || value === '') {
                changeValues(value, 'employee_points')
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e') {
                e.preventDefault()
              }
            }}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{translate?.comment}:</FormLabel>
        <textarea
          onChange={handleCommentChange}
          value={modalValue.employee_comment}
          placeholder={translate?.comment}
        />
      </FormField>
    </div>
  )
}

export default observer(PointsModal)
